$(function() {
	// @codekit-prepend 'js/functions.js'
    // @codekit-prepend 'js/dropdown.js'
    // @codekit-prepend 'js/pusher.js'
    
	// @codekit-prepend 'js/slider.js'

	// @codekit-prepend 'js/home-usd.js'
	// @codekit-prepend 'js/home-ils.js'
	// @codekit-prepend 'js/home-eur.js'

});